import React from 'react';
import { Link } from 'react-router-dom';

function CancelPage() {
  const pageStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#0f172a',
    color: '#e2e8f0'
  };

  const messageStyle = {
    fontSize: '1.8rem',
    color: '#F56565', // Red for cancel/error
    marginBottom: '20px'
  };

  const infoStyle = {
    fontSize: '1rem',
    color: '#A0AEC0',
    marginBottom: '30px'
  };

  const buttonStyle = {
    padding: '12px 25px',
    backgroundColor: '#4A5568',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '6px',
    fontSize: '1rem'
  };

  return (
    <div style={pageStyle}>
      <h1 style={messageStyle}>Payment Cancelled</h1>
      <p style={infoStyle}>
        Your payment process was cancelled. You have not been charged.
        <br />
        If you have any questions, please contact support.
      </p>
      <Link to="/subscriptions" style={buttonStyle}>View Plans Again</Link>
    </div>
  );
}

export default CancelPage; 